import {Component, NgZone, OnInit} from "@angular/core";
import {FormGroupDirective} from "@angular/forms";
import {ActivatedRoute} from "@angular/router";
import {BehaviorSubject} from "rxjs";
import {ISettings} from "../../../../models/auto-generated";
import {ScriptTesterComponent} from "../script-tester/script-tester.component";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import { FormGroup } from "@coso/forms";

@Component({
  standalone:false,
  templateUrl: "./script-editor.component.html",
  styleUrls: ["./script-editor.component.scss"]
})
export class ScriptEditorComponent implements OnInit {
  isEditorLoading = true;
  editorOptions: monaco.editor.IStandaloneEditorConstructionOptions;
  instanceId: string;

  isReadOnly = new BehaviorSubject<boolean>(false);

  get isReadOnly$() {
    return this.isReadOnly.asObservable();
  }

  formGroup: FormGroup<ISettings>;
  constructor(
    private ngZone: NgZone,
    private route: ActivatedRoute,
    private modalService: NgbModal,    
    private formGroupDirective: FormGroupDirective
  ) {}

  ngOnInit(): void {
    this.formGroup = this.formGroupDirective.control.get("settings") as FormGroup<ISettings>;
    this.editorOptions = { language: "lua", readOnly: false, ariaLabel: "Code here;Press Ctrl+B to focus previous element;Press Ctrl+P to focus next element" };
    this.instanceId = this.route.parent.snapshot.paramMap.get("instance-id");    
    this.isReadOnly$.subscribe((isReadOnly) => {
      this.editorOptions = { ...this.editorOptions, readOnly: isReadOnly };  
    });  
  }

  openScriptTester() {
    const modalRef = this.modalService.open(ScriptTesterComponent, {
      ariaLabelledBy: "modalTitle",
      keyboard: true,
      backdrop: "static",
      modalDialogClass: "modal-xl"
    });
    modalRef.componentInstance.instanceId = this.instanceId;
    modalRef.componentInstance.script = this.formGroup.controls.customScript.value;
    modalRef.componentInstance.applyCallback = (script: string) => {
      modalRef.close();
      this.formGroup.controls.customScript.patchValue(script);
      this.formGroup.controls.customScript.updateValueAndValidity();
    };
  }

  onMonacoInit(editor: monaco.editor.IStandaloneCodeEditor) {
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        this.isEditorLoading = false;
        // Get previous focusable element (Script Tester button)
        editor.addCommand(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KeyB, () => {
          const previous = document.getElementById("scriptTesterLauncherButton");
          previous?.focus();
        });
        // Get next focusable element (footer FAQ link)
        // eslint-disable-next-line no-bitwise
        editor.addCommand(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KeyP, () => {
          const next = document.getElementById("backButton");
          next?.focus();
        });
      });
    });
  }
}
